import { apiClientWithRefreshToken } from "@/api/apiClient";
import { UpdateUploadPurchaseOrderSchema } from "@/v2/schema/purchase-order";
import { PurchaseOrder } from "@/v2/types";

export default async function UpdateUploadPurchaseOrder({
    id,
    data,
}: {
    id: string;
    data: UpdateUploadPurchaseOrderSchema;
}): Promise<PurchaseOrder> {
    const formData = new FormData();

    formData.append("description", data.description);
    formData.append("remarks", data.remarks);
    formData.append("order_date", data.order_date);
    formData.append("expiration_date", data.expiration_date);
    formData.append("project", data.project);
    formData.append("purchase_order_number", data.purchase_order_number);
    formData.append("reference_number", data.reference_number);
    formData.append("status", data.status);
    if (data.client_id) formData.append("client_id", data.client_id);
    if (data.supplier_id) formData.append("supplier_id", data.supplier_id);
    formData.append("type", data.type);
    formData.append("rate_type", data.rate_type);
    formData.append("total_amount", String(data.total_amount));

    if (data.file && data.file.length > 0) {
        formData.append("file", data.file[0]);
    } else if (
        data.purchase_order_file_url &&
        data.purchase_order_file_url?.length > 0
    ) {
        formData.append(
            "purchase_order_file_url",
            data.purchase_order_file_url[0],
        );
    } else {
        formData.append("purchase_order_file_url", "");
    }

    const res = await apiClientWithRefreshToken({
        url: `/purchase-orders/${id}`,
        headers: {
            "Content-Type": "multipart/form-data",
        },
        method: "PUT",
        data: formData,
    });

    return res.data;
}
